export default __webpack_public_path__ + "static/media/77.36fae47b.png";